// ============================================================
// The sight wedge's shape (plan map-display, H): its width, the step its arc is drawn in, and the leader's narrower
// sweep. One place for the svg's wedges (components/display/SightWedges) and the CSS plane's (WedgePlane).
// Pure.
// ============================================================

/** Half a watcher's wedge, degrees; and the step its arc is drawn in. */
export const WEDGE_HALF = 30;
const WEDGE_STEP = 10;

/** The leader's sweep (Z2, the stealth page): a narrow wedge 14 m out. */
export const LEADER_M = 14;
export const LEADER_HALF = 10;

/** The arc's bearings, degrees, from `facing - half` to `facing + half` in WEDGE_STEP steps. */
export function arcBearings(facing: number, half: number): number[] {
  const out: number[] = [];
  for (let a = facing - half; a <= facing + half; a += WEDGE_STEP) out.push(a);
  return out;
}

/** A wedge as points about its apex (0, 0), `reach` out along bearing 0, `half` either side; x along 0°. */
export function fanPoints(reach: number, half: number): string {
  const rim = arcBearings(0, half).map((a) => {
    const r = (a * Math.PI) / 180;
    return `${(reach * Math.cos(r)).toFixed(1)},${(reach * Math.sin(r)).toFixed(1)}`;
  });
  return ['0,0', ...rim].join(' ');
}
